import React from 'react'
import { useTranslation } from 'react-i18next'
import { StandardCard } from '../../../../components/shared/standardCard/standardCard'

export interface MetersCardProps {
  isLoading?: boolean
}

export const MetersCard: React.FC<MetersCardProps> = ({ isLoading, children }) => {
  const [t] = useTranslation(['globalerisLibrary', 'meters'])

  return (
    <StandardCard title={t('meters:components.metersCard.title')} isLoading={isLoading}>
      {children}
    </StandardCard>
  )
}
